import script from "./compile.vue?vue&type=script&setup=true&lang=js"
export * from "./compile.vue?vue&type=script&setup=true&lang=js"

import "./compile.vue?vue&type=style&index=0&id=9e84b0de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e84b0de"]])

export default __exports__